import Chart, { ChartData, ChartOptions } from "chart.js/auto";
import { Column } from "exceljs";
import { useEffect, useMemo, useRef, useState } from "react";
import { ListFieldsRecordType, ListFieldsType, myDocumentsListName, siteUrl } from "src/api/config";
import { notificationsListName } from "src/api/config/notifications.config";
import Loading from "src/components/Loading";
import AuditReportTable, { AuditReportTableType } from "src/components/tables/AuditReportTableWithFilters";
import { isFiltersObjectEmpty } from "src/components/tables/NotifyReportTableWithFilters";
import { NotificationIcon, ReportIcon } from "src/components/ui-icons/sidebar";
import { SearchUI } from "src/components/ui/Search";
import { TGCheckList } from "src/components/ui/TGCheckList";
import { TGDisclosure } from "src/components/ui/TGDisclosure";
import { TGSelectPicker, TGSelectUserPickerByGroup } from "src/components/ui/TGSelect";
import { UserAvatarType2 } from "src/components/ui/TGUserAvatarsList";
import { useFiltersContext } from "src/contexts/FilterContext";
import useAsyncEffect from "src/hooks/useAsyncEffect";
import ExportToExcel from "src/modules/exelExport/exelExport";
import { FetchOptions, getItemsRequest } from "src/modules/spItems/api";
import { modifiedItemsState } from "src/modules/spItems/selectors";
import { getUserProperties } from "src/modules/users/api";
import { CheckBoxListItem, UserDataRecordType } from "src/types/main";
import { chunkArray, getName } from "src/utils/array.utils";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { nameFromEmail, prefix, removePrefix, shortNameFromEmail } from "src/utils/users.utils";
import DocumentFilters from "../../DashboardPage/acadia/components/Filters/DocumentFilters";
import { LayoutWithAsideAndContent } from "../../LayoutWithAsideAndContent";
import { SubmitAuditFiltersType, SubmitEmployeeState } from "../types";
import { useGetUsers } from "./../../../hooks/useGetUsers";
import { twMerge } from "tailwind-merge";
import { isEqual } from "lodash";
import moment from "moment";
import TGDatePicker from "src/components/ui/TGDatePicker";
import { DateValueType } from "react-tailwindcss-datepicker";
import { useStore } from "react-redux";
import { AppStore } from "src/store";
import { getNameAndSurname } from "./../../../utils/users.utils";
import { User } from "src/modules/users/types";
import { buildSearchQuery } from "src/utils/api.utils";
import { removeInvisibleChar } from "src/utils/string.utils";
import { documentFiltersOptions } from "src/hooks/useGetDocuments";
import { strapiUrl } from "src/modules/users/constants";
import axios from "axios";
import { isStrapi, notificationStatuses } from "src/api/config/systemSwitch";

export function ReportPageFilterBreadcrumbLayout() {
  return (
    <nav className="flex justify-between w-full" aria-label="Breadcrumb">
      <FlexCol className="grow">
        <ol className="inline-flex items-center">
          <li className="inline-flex items-center" aria-current="page">
            <div className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer">
              <ReportIcon />
              <span>Отчеты</span>
            </div>
            <span className="px-3 text-body-color">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.2 8.55001L10.3781 2.64376C10.125 2.39064 9.73126 2.39064 9.47813 2.64376C9.22501 2.89689 9.22501 3.29064 9.47813 3.54376L14.2031 8.35314H2.25001C1.91251 8.35314 1.63126 8.63439 1.63126 8.97189C1.63126 9.30939 1.91251 9.61876 2.25001 9.61876H14.2594L9.47813 14.4844C9.22501 14.7375 9.22501 15.1313 9.47813 15.3844C9.59063 15.4969 9.75938 15.5531 9.92813 15.5531C10.0969 15.5531 10.2656 15.4969 10.3781 15.3563L16.2 9.45001C16.4531 9.19689 16.4531 8.80314 16.2 8.55001Z"
                  fill={"#637381"}
                />
              </svg>
            </span>
          </li>
          <li className="inline-flex items-center" aria-current="page">
            <div className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer">
              <NotificationIcon className="w-[18px] h-[18px]" />
              <span>Отчет по ознакомлению</span>
            </div>
          </li>
        </ol>
      </FlexCol>
    </nav>
  );
}

function calculateAverageAnswerRate(objectsArray: ListFieldsRecordType[typeof notificationsListName][]) {
  // Фильтруем только те объекты, где есть значение test
  const filteredObjects = objectsArray.filter((obj) => obj.Test !== null);

  // Если таких объектов нет, возвращаем "----"
  if (filteredObjects.length === 0) {
    return "----";
  }

  // Подсчитываем сумму всех answerRate и делим на количество таких объектов
  const totalAnswerRate = filteredObjects.reduce((sum, obj) => sum + obj.TestAnswerRate, 0);
  const averageAnswerRate = totalAnswerRate / filteredObjects.length;

  // Возвращаем средний процент результата
  return averageAnswerRate;
}

function modifiedListByAuditTable(
  documentItem: ListFieldsType[typeof myDocumentsListName],
  filters: SubmitAuditFiltersType,
  notifications: ListFieldsType[typeof notificationsListName][],
) {
  let tempData: AuditReportTableType[] = [];
  let tempNotifications: ListFieldsType[typeof notificationsListName][] = [];

  const tempElement: AuditReportTableType = {
    ID: documentItem.ID,
    PublicationDate: documentItem.PublicationDate.format("DD.MM.YYYY HH:mm"),
    Document: {
      Code: documentItem.Code,
      Name: documentItem.Title,
    },
    Author: {
      Avatar: null,
      Email: documentItem.AuthorEmail,
      ID: documentItem.Author.ID,
      Name: nameFromEmail(documentItem.AuthorEmail),
      Title: nameFromEmail(documentItem.AuthorEmail),
      TitleRus: nameFromEmail(documentItem.AuthorEmail),
      JobTitle: nameFromEmail(documentItem.AuthorEmail),
      JobTitleRus: nameFromEmail(documentItem.AuthorEmail),
      Metadata: null,
    },
    AuditEmployees: [],
    AuditPercentage: 0,
    AverageTestResult: 0,
    Version: documentItem.Ver,
  };

  const notificationsResponse = notifications.filter((notification: ListFieldsType[typeof notificationsListName]) => {
    const documentMatch = documentItem ? documentItem.ID === notification.Document.ID : true;

    const auditMatch = filters.audit.length
      ? filters.audit.some((d) => d.id === notification.NotificationType.ID)
      : true;

    const employeesMatch = filters.employees.length
      ? filters.employees.some((d) => notification.EmployeeEmail === d)
      : true;

    // Фильтрация пройдет, только если оба условия выполнены
    return documentMatch && auditMatch && employeesMatch;
  });

  tempNotifications.push(...notificationsResponse);

  if (notificationsResponse.length > 0) {
    let averageTestResult = {
      percent: 0,
      count: 0,
    }; //* Средний результат тестирования

    let auditPercentage = 0; //* Процент ознакомления

    let auditEmployees: Map<string, UserAvatarType2> = new Map(); //* Ознакомившиеся сотрудники

    // Храним последнее уведомление по дате для каждого пользователя
    const lastNotificationByUser = new Map<string, (typeof notificationsResponse)[0]>();

    notificationsResponse.forEach((notificationItem) => {
      if (notificationItem.Completed) {
        auditPercentage = auditPercentage + 1;
      }

      if (notificationItem.Test) {
        averageTestResult = {
          percent: averageTestResult.percent + notificationItem.TestAnswerRate,
          count: averageTestResult.count + 1,
        };
      }

      if (notificationItem.EmployeeEmail) {
        const email = notificationItem.EmployeeEmail.toLowerCase();
        const existing = lastNotificationByUser.get(email);

        // Если пользователя ещё нет или текущее уведомление новее — обновляем
        if (!existing || moment(notificationItem.Created).valueOf() > moment(existing.Created).valueOf()) {
          lastNotificationByUser.set(email, notificationItem);
        }
      }
    });

    // Теперь для каждого пользователя определяем статус по последнему уведомлению
    lastNotificationByUser.forEach((lastNotification, email) => {
      const isCancelled = lastNotification.Title.includes("Отклонено");

      // Приоритет: последнее уведомление определяет статус
      // - отклонено → "canceled"
      // - выполнено → "success"
      // - иначе → "pending"
      const status = isCancelled ? "canceled" : lastNotification.Completed ? "success" : "pending";

      const user: UserAvatarType2 = {
        shortName: shortNameFromEmail(lastNotification.EmployeeEmail),
        email: lastNotification.EmployeeEmail,
        name: nameFromEmail(lastNotification.EmployeeEmail),
        status: status,
      };

      auditEmployees.set(email, user);
    });

    tempElement.AverageTestResult =
      averageTestResult.count > 0 ? averageTestResult.percent / averageTestResult.count : null;

    tempElement.AuditPercentage =
      auditPercentage !== 0 ? Math.floor((auditPercentage / notificationsResponse.length) * 100) : 0;

    tempElement.AuditEmployees = [...auditEmployees.values()];

    tempData.push(tempElement);
  }

  let tempDiagramData = tempNotifications.length
    ? computeCompleteAndUncompleteItems(tempNotifications)
    : computeCompleteAndUncompleteItems(notifications);

  return { data: tempData, diagramData: tempDiagramData };
}

function LevelsOfAudit({
  submitCountOfAudit,
  sum,
}: {
  submitCountOfAudit: {
    completed: number;
    uncompleted: number;
    cancelled: number;
  };
  sum: number;
}) {
  const completedCount = (submitCountOfAudit.completed / sum) * 100;
  const uncompletedCount = (submitCountOfAudit.uncompleted / sum) * 100;
  const cancelledCount = (submitCountOfAudit.cancelled / sum) * 100;

  return (
    <div>
      <h5 className="font-medium text-black">Уровень ознакомлений</h5>
      <div className="flex items-center mt-2.5">
        <span className="block w-1 h-4 mr-2 bg-[#5475E5] rounded-full"></span>
        <p>
          {Math.round(isNaN(completedCount) ? 0 : completedCount)}% ({submitCountOfAudit.completed}) завершенных
          ознакомлений
        </p>
      </div>
      <div className="flex items-center mt-1">
        <span className="block w-1 h-4 mr-2 bg-[#E1E8FF] rounded-full"></span>
        <p>
          {Math.round(isNaN(uncompletedCount) ? 0 : uncompletedCount)}% ({submitCountOfAudit.uncompleted}) незавершенных
          ознакомлений
        </p>
      </div>
      <div className="flex items-center mt-1">
        <span className="block w-1 h-4 mr-2 bg-[#18BFFF] rounded-full"></span>
        <p>
          {Math.round(isNaN(cancelledCount) ? 0 : cancelledCount)}% ({submitCountOfAudit.cancelled}) отклоненных
          ознакомлений
        </p>
      </div>
    </div>
  );
}

export type LoadingStatus = "initial" | "pending" | "success";

export function AuditReport() {
  const { users, downloading: usersLoading } = useGetUsers();

  // submit filters

  const [submitFilters, setSubmitFilters] = useState<SubmitAuditFiltersType>({
    employees: [],
    audit: [],
    created: {
      startDate: moment.utc().startOf("week").toDate(),
      endDate: moment.utc().endOf("week").toDate(),
    }, //! change 'week' to "month"
  });

  // submit filters

  return (
    <LayoutWithAsideAndContent
      aside={
        <AuditReportFilters
          users={users}
          downloading={usersLoading}
          submitFilters={submitFilters}
          changeSubmitFilters={(type, e) => {
            setSubmitFilters(e);
          }}
        />
      }
      content={<AuditReportTableWrapper submitFilters={submitFilters} />}
    />
  );
}

function AuditReportTableWrapper({ submitFilters }: { submitFilters: SubmitAuditFiltersType }) {
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [audits, setAudits] = useState<AuditReportTableType[]>([]);
  const [filteredAudits, setFilteredAudits] = useState<AuditReportTableType[]>([]); // ⭐ Отфильтрованные данные

  const [diagram, setDiagram] = useState<{
    completed: number;
    uncompleted: number;
    cancelled: number;
  }>({ completed: 0, uncompleted: 0, cancelled: 0 });

  const { filters } = useFiltersContext();

  function handleSearch(value: string) {
    setSearchQuery(value);
  }

  useAsyncEffect(async () => {
    setLoading(true);
    try {
      const requestProps: FetchOptions<typeof myDocumentsListName> = {
        listName: myDocumentsListName,
        filters: {
          PublicationDate: {
            start: moment.utc(submitFilters.created?.startDate).startOf("day").toDate(),
            end: moment.utc(submitFilters.created?.endDate).endOf("day").toDate(),
          },
        },
        sortOrder: { name: "Created", desc: true },
      };

      if (filters) {
        requestProps.filters = {
          ...requestProps.filters,
          ...documentFiltersOptions(filters),
        }; // Применение фильтров, если они переданы
      }

      const documentsResponse = await getItemsRequest(requestProps);

      const tempAudits: AuditReportTableType[] = [];
      const tempDiagram: {
        completed: number;
        uncompleted: number;
        cancelled: number;
      } = {
        completed: 0,
        uncompleted: 0,
        cancelled: 0,
      };

      const allUserEmails = new Set();
      const documents = modifiedItemsState(documentsResponse.items, myDocumentsListName);

      const chunkDocuments = chunkArray(documents, 2);

      for (const chunk of chunkDocuments) {
        // 🔹 Запускаем все запросы параллельно
        const promises = chunk.map(async (document) => {
          // Получаем уведомления
          const notificationResponse = await getItemsRequest({
            listName: notificationsListName,
            filters: { Document: [document.ID] },
          });

          // Обрабатываем всех сотрудников (извлекаем email)
          notificationResponse.items.forEach((d) => allUserEmails.add(d.EmployeeEmail));
          allUserEmails.add(document.AuthorEmail);

          const notifications = modifiedItemsState(notificationResponse.items, notificationsListName);

          const filteredAuditNotifications = notifications.filter(
            (item) =>
              item.NotificationType.ID === notificationStatuses.acquainted ||
              item.NotificationType.ID === notificationStatuses.acquaintedTest ||
              item.NotificationType.ID === notificationStatuses.familiarization ||
              item.Title.includes("Отклонено"),
          );

          // Запрашиваем данные документа
          const {
            data: [modifiedDocument],
            diagramData,
          } = modifiedListByAuditTable(document, submitFilters, filteredAuditNotifications);

          // Добавляем в результаты
          return { modifiedDocument, diagramData };
        });

        // Ждём завершения всех запросов в текущем `chunk`
        const results = (await Promise.allSettled(promises))
          .filter((p) => p.status === "fulfilled")
          .filter((p) => p.value.modifiedDocument);

        const modifiedAudits = results.reduce<AuditReportTableType[]>(
          (acc, r) => [...acc, r.value.modifiedDocument],
          [],
        );

        // 🔹 Обновляем состояние одним разом (эффективнее)
        tempAudits.push(...modifiedAudits);
        tempDiagram.completed =
          tempDiagram.completed + results.reduce((sum, r) => sum + r.value.diagramData.completed, 0);
        tempDiagram.uncompleted =
          tempDiagram.uncompleted + results.reduce((sum, r) => sum + r.value.diagramData.uncompleted, 0);
        tempDiagram.cancelled =
          tempDiagram.cancelled + results.reduce((sum, r) => sum + r.value.diagramData.cancelled, 0);
      }

      setAudits(tempAudits);

      setDiagram(tempDiagram);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [JSON.stringify(submitFilters), JSON.stringify(filters)]);

  useEffect(() => {
    if (searchQuery.trim()) {
      const tempAudits = [...audits];
      const filtered = tempAudits.filter((item) => {
        const searchLower = searchQuery.toLowerCase().trim();
        const titleMatch = item.Document.Name?.toLowerCase().includes(searchLower);
        const codeMatch = item.Document.Code?.toLowerCase().includes(searchLower);

        return titleMatch || codeMatch;
      });
      setFilteredAudits(filtered); // ⭐ Обновляем только отфильтрованные
    } else {
      setFilteredAudits(audits); // ⭐ Показываем все оригинальные данные
    }
  }, [searchQuery, audits]);

  return (
    <FlexCol className="w-full">
      <FlexRow className="px-7.5 h-[76px] border-b justify-between items-center shrink-0">
        <FlexCol>
          <ReportPageFilterBreadcrumbLayout />
        </FlexCol>
        <FlexCol>
          <ExportToExcelButton data={audits} disabled={!audits.length || loading} />
        </FlexCol>
      </FlexRow>
      <FlexRow className="px-7.5 py-7.5 justify-center space-x-[15px]">
        <ChartUI data={diagram} loading={loading} />
      </FlexRow>
      <FlexRow className="px-7.5 mb-3.5">
        <SearchUI placeholder="Поиск по документу" defaultValue={searchQuery} onClick={handleSearch} />
      </FlexRow>
      <FlexRow className="px-7.5 py-7.5">
        <AuditReportTable body={filteredAudits} loading={loading} />
      </FlexRow>
    </FlexCol>
  );
}

function ChartUI({
  data,
  loading,
}: {
  data: {
    completed: number;
    uncompleted: number;
    cancelled: number;
  };
  loading: boolean;
}) {
  const sum = data.completed + data.uncompleted + data.cancelled;

  return (
    <>
      <FlexCol>
        <CircularChart countOfAudit={data} />
      </FlexCol>
      <FlexCol className={twMerge(loading ? "animate-pulse" : "")}>
        <LevelsOfAudit submitCountOfAudit={data} sum={sum} />
      </FlexCol>
    </>
  );
}

type ExportDataType = {
  columns: Partial<Column>[];
  data: any[];
};

const exportTempData: ExportDataType = {
  columns: [
    { header: "Ссылка на документ", key: "External_Link", width: 50 },
    { header: "Код документа", key: "DocumentCode", width: 50 },
    { header: "Версия документа", key: "Version", width: 50 },
    { header: "Владелец документа", key: "Author", width: 50 },
    { header: "Дата публикации", key: "PublicationDate", width: 30 },
    { header: "Ознакомившиеся сотрудники", key: "AuditEmployees", width: 50 },
    { header: "Процент ознакомления", key: "AuditPercentage", width: 30 },
    {
      header: "Средний результат тестирования",
      key: "AverageTestResult",
      width: 40,
    },
  ],
  data: [],
};

function ExportToExcelButton({ data, disabled }: { data: AuditReportTableType[]; disabled: boolean }) {
  const [exportData, setExportData] = useState<ExportDataType | {}>(exportTempData);

  const store = useStore<AppStore>();
  const { users } = store.getState();

  useAsyncEffect(async () => {
    if (!disabled) {
      const tempData: any[] = [];
      const usersMap = new Map();

      for (const d of data) {
        const baseData = {
          External_Link: {
            text: d.Document.Name,
            hyperlink: `${siteUrl}/dashboard/1/reports/3?documentCard=${d.ID}`,
            tooltip: d.Document.Name,
          },
          DocumentCode: d.Document.Code,
          Author: d.Author.Email + " Нет данных",
          PublicationDate: d.PublicationDate,
          AuditEmployees: d.AuditEmployees.map((emp) => emp.email).join(", "),
          AuditPercentage: d.AuditPercentage + "%",
          AverageTestResult: d.AverageTestResult ? d.AverageTestResult + "%" : "----",
          Version: d.Version,
        };

        const user: User = users.items[d.Author.Email];

        if (user) {
          baseData.Author = !!user.UserProfileProperties.length
            ? getNameAndSurname(user.DisplayName, d.Author.Email) +
              ` (${
                user.UserProfileProperties.find((u) => u.Key === "abiGlobalID").Value ||
                user.UserProfileProperties.find((u) => u.Key === "EmployeeNumber").Value ||
                "Нет номера"
              })`
            : user.DisplayName;
        } else if (usersMap.has(d.Author.Email)) {
          const user = usersMap.get(d.Author.Email);
          baseData.Author = user;
        } else {
          let personalNumber = "0";

          try {
            const responseUser = await getUserProperties(d.Author.Email, ["abiGlobalID", "PreferredName"]);

            if (responseUser && responseUser.abiGlobalID) {
              personalNumber = responseUser.abiGlobalID;

              baseData.Author =
                getNameAndSurname(responseUser.PreferredName, d.Author.Email) +
                ` (${!!personalNumber ? personalNumber : "Нет данных"})`;

              usersMap.set(d.Author.Email, baseData.Author);
            }
          } catch (error) {
            console.error("В personalNumber нет данных");
            baseData.Author = d.Author.Email + " Нет данных";
          }
        }

        tempData.push(baseData);
      }

      setExportData((prev) => ({ ...prev, data: tempData }));
    }
  }, [JSON.stringify(data)]);

  const fileName = "Отчет Аудита";

  return <ExportToExcel disabled={disabled} exportData={exportData} fileName={fileName} type="audit_report" />;
}

function computeCompleteAndUncompleteItems(items: ListFieldsType[typeof notificationsListName][]) {
  return items.reduce(
    (acc, cur) => {
      if (cur.Title.includes("Отклонено")) {
        acc.cancelled = acc.cancelled + 1;
      } else {
        if (cur.Completed) {
          acc.completed = acc.completed + 1;
        } else {
          acc.uncompleted = acc.uncompleted + 1;
        }
      }

      return acc;
    },
    { completed: 0, uncompleted: 0, cancelled: 0 },
  );
}

function CircularChart({
  countOfAudit,
}: {
  countOfAudit: { completed: number; uncompleted: number; cancelled: number };
}) {
  return (
    <CircularChartUI
      completed={countOfAudit.completed}
      uncompleted={countOfAudit.uncompleted}
      cancelled={countOfAudit.cancelled}
    />
  );
}

const CircularChartUI = ({
  completed = 0,
  uncompleted = 0,
  cancelled = 0,
}: {
  completed?: number;
  uncompleted?: number;
  cancelled?: number;
}) => {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const chartInstance = useRef<Chart<"doughnut"> | null>(null);

  useEffect(() => {
    if (!chartRef.current) return;

    const ctx = chartRef.current.getContext("2d");
    if (!ctx) return;

    // Данные графика: выполненные, невыполненные, отклоненные
    const data: ChartData<"doughnut"> = {
      labels: ["Выполнено", "Не выполнено", "Отклонено"],
      datasets: [
        {
          data: [completed, uncompleted, cancelled],
          backgroundColor: ["#5475E5", "#E1E8FF", "#18BFFF"],
          hoverBackgroundColor: ["#5475E5", "#E1E8FF", "#18BFFF"],
          borderWidth: 0,
        },
      ],
    };

    // Опции графика
    const options: ChartOptions<"doughnut"> = {
      maintainAspectRatio: false,
      responsive: true,
      cutout: "70%",
      rotation: 0,
      circumference: 360,
      animation: {
        animateRotate: true,
        duration: 0,
      },
      plugins: {
        datalabels: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
    };

    // Если график уже создан — просто обновляем данные
    if (chartInstance.current) {
      chartInstance.current.data.datasets[0].data = [completed, uncompleted, cancelled];
      chartInstance.current.update();
    } else {
      // Создаем график, если его нет
      chartInstance.current = new Chart(ctx, {
        type: "doughnut",
        data,
        options,
      });
    }
  }, [completed, uncompleted, cancelled]);

  return (
    <div className="w-[108px] h-[108px] rotate-45">
      <canvas ref={chartRef} />
    </div>
  );
};

function AuditReportFilters({
  submitFilters,
  changeSubmitFilters,
  users,
  downloading,
}: {
  submitFilters: SubmitAuditFiltersType;
  changeSubmitFilters: (type: string, e: SubmitAuditFiltersType) => void;
  users: UserDataRecordType[];
  downloading: boolean;
}) {
  const { filters, resetFilters: resetDocumentsFilters } = useFiltersContext();

  const [loading, setLoading] = useState(false);

  const [selectedAttrEmployees, setSelectedAttrEmployees] = useState<SubmitEmployeeState>({
    departments: [],
    groupPeople: [],
    locations: [],
    positions: [],
    searchQuery: "",
  });

  function checkAudit(value: CheckBoxListItem) {
    let newValue = [...submitFilters.audit];
    if (newValue.length > 0 && newValue.find((f) => f.id === value.id)) {
      const filtered = submitFilters.audit.filter((n) => n.id !== value.id);

      newValue = filtered;
    } else {
      newValue.push(value);
    }

    changeSubmitFilters("audit", { ...submitFilters, audit: newValue });
  }

  function checkCreatedDate(value: DateValueType) {
    changeSubmitFilters("created", { ...submitFilters, created: value });
  }

  // Чистит всё
  function clearAll() {
    const resetData: Record<keyof SubmitAuditFiltersType, any> = {
      employees: [],
      audit: [],
      created: {
        startDate: moment.utc().startOf("week").toDate(),
        endDate: moment.utc().endOf("week").toDate(),
      },
    };

    changeSubmitFilters("reset", resetData);

    setSelectedAttrEmployees({
      departments: [],
      groupPeople: [],
      locations: [],
      positions: [],
      searchQuery: "",
    });

    resetDocumentsFilters();
  }

  async function changeAttrByType(options: SubmitEmployeeState) {
    setSelectedAttrEmployees(options);
  }

  useAsyncEffect(async () => {
    setLoading(true);
    try {
      const { departments, groupPeople, locations, positions, searchQuery: query } = selectedAttrEmployees;

      if (
        !query &&
        departments.length === 0 &&
        positions.length === 0 &&
        locations.length === 0 &&
        groupPeople.length === 0
      ) {
        changeSubmitFilters("update", {
          ...submitFilters,

          employees: [],
        });
        return;
      }

      if (groupPeople.length) {
        const flatGroupPeople = groupPeople
          .flatMap((group) => group.value)
          .map((email: string) => removeInvisibleChar(removePrefix(email, prefix)));

        const chunksPeople = chunkArray(flatGroupPeople, 10);

        const chunksPromisePeople = chunksPeople.map((chunkPeople) => {
          let searchQuery = buildSearchQuery(
            query,
            departments.map(getName),
            positions.map(getName),
            locations.map(getName),
            chunkPeople,
            [],
            [],
          );

          return axios.get(`${strapiUrl}users?${searchQuery}`, {
            headers: {
              Accept: "application/json;odata=nometadata",
              "Content-Type": "application/json;odata=nometadata",
            },
            withCredentials: true,
          });

        });

        try {
          const allResponses = await Promise.all(chunksPromisePeople);

          const userEmails: string[] = [];

          if (isStrapi) {
            for (const response of allResponses) {
              if ((response as any).data.length > 0) {
                const employeesEmails: string[] = (response as any).data.map((user: any) => {
                  const email = user.email;
                  return email;
                });
                userEmails.push(...employeesEmails);
              }
            }
          } else {
            for (const response of allResponses) {
              if ((response as any).get_value().ResultTables.length > 0) {
                const employeesEmails: string[] = (response as any)
                  .get_value()
                  .ResultTables[0].ResultRows.map((user: any) => {
                    const email = removePrefix(user.AccountName, prefix);

                    return email;
                  });

                userEmails.push(...employeesEmails);
              }
            }
          }
          if (userEmails.length) {
            changeSubmitFilters("update", {
              ...submitFilters,

              employees: userEmails,
            });
          } else {
            changeSubmitFilters("update", {
              ...submitFilters,

              employees: [],
            });
          }
        } catch (error) {
          console.error("chunksPromisePeople", error);
        }
      } else {
        let searchQuery = buildSearchQuery(
          query,
          departments.map(getName),
          positions.map(getName),
          locations.map(getName),
          [],
          [],
          [],
        );

        let userEmails: string[] = [];

        const response = await axios.get(`${strapiUrl}users?${searchQuery}`, {
          headers: {
            Accept: "application/json;odata=nometadata",
            "Content-Type": "application/json;odata=nometadata",
          },
          withCredentials: true,
        });
        if (response.data.length > 0) {
          userEmails = response.data.map((user: any) => {
            const email = user.email;
            return email;
          });
        }
        if (userEmails.length > 0) {
          changeSubmitFilters("update", {
            ...submitFilters,

            employees: userEmails,
          });
        } else {
          changeSubmitFilters("update", {
            ...submitFilters,

            employees: [],
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [selectedAttrEmployees]);

  // useAsyncEffect(async () => {
  //   if (!downloading && users.length > 0) {
  //     setLoading(true);
  //     try {
  //       const filterUsers: UserDataRecordType[] = users.filter((user: UserDataRecordType) => {
  //         // Проверка по Department и Region одновременно (через И)
  //         const departmentMatch = selectedAttrEmployees.departments.length
  //           ? selectedAttrEmployees.departments.some((d) => d.name === user.Department)
  //           : true; // Если фильтры для Department отсутствуют, считаем это условие выполненным

  //         const regionMatch = selectedAttrEmployees.locations.length
  //           ? selectedAttrEmployees.locations.some((d) => d.name === user.Region || d.name === user.BaseOfficeLocation)
  //           : true; // Если фильтры для Region отсутствуют, считаем это условие выполненным

  //         const groupMatch =
  //           selectedAttrEmployees.groupPeople.length && selectedAttrEmployees.groupPeople[0].value.length
  //             ? selectedAttrEmployees.groupPeople[0].value.some((email: string) =>
  //                 user.WorkEmail ? email.toLowerCase().includes(user.WorkEmail.toLowerCase()) : false
  //               )
  //             : true; // Если фильтры для Region отсутствуют, считаем это условие выполненным

  //         const positionMatch = selectedAttrEmployees.positions.length
  //           ? selectedAttrEmployees.positions.some((d) => d.name === user.JobTitle)
  //           : true; // Если фильтры для Region отсутствуют, считаем это условие выполненным

  //         const queryMatch = selectedAttrEmployees.searchQuery.length
  //           ? (user.PreferredName &&
  //               user.PreferredName.toLowerCase().includes(selectedAttrEmployees.searchQuery.toLowerCase())) ||
  //             (user.FirstName &&
  //               user.FirstName.toLowerCase().includes(selectedAttrEmployees.searchQuery.toLowerCase())) ||
  //             (user.LastName &&
  //               user.LastName.toLowerCase().includes(selectedAttrEmployees.searchQuery.toLowerCase())) ||
  //             (user.apiGlobalID &&
  //               user.apiGlobalID.toLowerCase().includes(selectedAttrEmployees.searchQuery.toLowerCase())) ||
  //             (user.abiGlobalID &&
  //               user.abiGlobalID.toLowerCase().includes(selectedAttrEmployees.searchQuery.toLowerCase())) ||
  //             (user.UserName && user.UserName.toLowerCase().includes(selectedAttrEmployees.searchQuery.toLowerCase()))
  //           : true; // Если фильтры для Region отсутствуют, считаем это условие выполненным

  //         // Фильтрация пройдет, только если оба условия выполнены
  //         return departmentMatch && groupMatch && regionMatch && positionMatch && queryMatch;
  //       });

  //       const userEmails = filterUsers.length ? filterUsers.map((f) => removePrefix(f.AccountName, prefix)) : [];

  //       changeSubmitFilters("update", {
  //         ...submitFilters,

  //         employees: userEmails,
  //       });
  //     } catch (error) {
  //       console.error(error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // }, [selectedAttrEmployees]);

  const isFiltersEmpty = useMemo(() => {
    const isEmployeesEmpty =
      !!selectedAttrEmployees.departments.length ||
      !!selectedAttrEmployees.groupPeople.length ||
      !!selectedAttrEmployees.locations.length ||
      !!selectedAttrEmployees.positions.length ||
      !!selectedAttrEmployees.searchQuery;

    const isCreatedDateEmpty =
      !isEqual(submitFilters.created?.startDate, moment.utc().startOf("week").toDate()) &&
      !isEqual(submitFilters.created?.endDate, moment.utc().endOf("week").toDate()); //! change 'week' to "month"
    const isAuditEmpty = !!submitFilters.audit.length;

    return isFiltersObjectEmpty(filters) || isEmployeesEmpty || isAuditEmpty || isCreatedDateEmpty;
  }, [filters, JSON.stringify(submitFilters)]);

  return (
    <FlexCol className="overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] h-full">
      {isFiltersEmpty && (
        <FlexRow className="flex-nowrap gap-x-2 items-center p-5 border-b cursor-pointer group" onClick={clearAll}>
          <FlexCol className="group-hover:underline">Сбросить все фильтры</FlexCol>
          <FlexCol>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_381_6476)">
                <path
                  d="M7.9999 7.19998L1.8999 1.09998C1.6749 0.874975 1.3249 0.874975 1.0999 1.09998C0.874902 1.32498 0.874902 1.67497 1.0999 1.89997L7.1999 7.99998L1.0999 14.1C0.874902 14.325 0.874902 14.675 1.0999 14.9C1.3249 15.125 1.6749 15.125 1.8999 14.9L7.9999 8.79998L14.0999 14.9C14.3249 15.125 14.6749 15.125 14.8999 14.9C14.9999 14.8 15.0749 14.65 15.0749 14.5C15.0749 14.35 15.0249 14.2 14.8999 14.1L8.7999 7.99998L14.8999 1.89997C14.9999 1.79997 15.0749 1.64997 15.0749 1.49998C15.0749 1.34998 15.0249 1.19998 14.8999 1.09998C14.6749 0.874975 14.3249 0.874975 14.0999 1.09998L7.9999 7.19998Z"
                  fill="#637381"
                />
              </g>
              <defs>
                <clipPath id="clip0_381_6476">
                  <rect width="16" height="16" fill="white" transform="translate(0 16) rotate(-90)" />
                </clipPath>
              </defs>
            </svg>
          </FlexCol>
        </FlexRow>
      )}

      <TGDisclosure title="Атрибуты документа" panelClassName="px-0">
        <DocumentFilters />
      </TGDisclosure>

      <TGDisclosure title="Атрибуты ознакомившихся сотрудников">
        {downloading ? (
          <div className="flex justify-center items-center grow">
            <Loading />
          </div>
        ) : (
          <ContentArea initial={selectedAttrEmployees} type="audit" changeAttr={changeAttrByType} />
        )}
      </TGDisclosure>

      <TGDisclosure title="Ознакомление">
        <TGCheckList
          list={[
            { id: 4, title: "С тестом" },
            { id: 5, title: "Без теста" },
          ]}
          items={submitFilters.audit}
          onChecked={checkAudit}
        />
      </TGDisclosure>
      <TGDisclosure title="Дата публикации документа" defaultOpen={true}>
        <FlexCol className="relative z-[50] w-full gap-y-3.5">
          <h4 className={"font-normal"}>От и До</h4>
          <TGDatePicker value={submitFilters.created} onChange={checkCreatedDate} popoverDirection="down" />
        </FlexCol>
      </TGDisclosure>
    </FlexCol>
  );
}

type EmployeeAttributeType = "send" | "audit" | "teacher_owd" | "employee_owd";

function ContentArea({
  type,
  initial,
  changeAttr,
}: {
  type: EmployeeAttributeType;
  initial: SubmitEmployeeState;
  changeAttr: (options: SubmitEmployeeState) => void;
}) {
  const searchInputRef = useRef<HTMLInputElement>(null);

  function handleSearch(value: string) {
    changeAttr({ ...initial, searchQuery: value });
  }

  return (
    <FlexCol className="grow custom-selects">
      <FlexRow>
        <TGSelectPicker
          values={initial.locations}
          min={0}
          onChange={(values) => changeAttr({ ...initial, locations: values })}
          fetchKey={["SPS-Location", "Region", "BaseOfficeLocation"]}
          classNames={{
            contentClassName: "text-base font-normal",
            selectClassName: "!px-2.5",
          }}
          dataField={{
            placeholder: "Выберите вариант",
            type: "peoplePicker",
            require: false,
            title: "Локация",
            width: "w-full",
            key: "peoplePicker",
            single: true,
          }}
          errors={{}}
        />
      </FlexRow>
      <FlexRow>
        <TGSelectUserPickerByGroup
          values={initial.groupPeople}
          onChange={(values) => changeAttr({ ...initial, groupPeople: values })}
          fetchKey="Region"
          classNames={{
            contentClassName: "text-base font-normal",
            selectClassName: "!px-2.5",
          }}
          dataField={{
            placeholder: "Выберите группу",
            type: "peoplePicker",
            require: false,
            title: "Группа сотрудников",
            width: "w-full",
            key: "peoplePicker",
            single: true,
          }}
          clear={true}
          min={0}
          errors={{}}
        />
      </FlexRow>

      <FlexRow>
        <TGSelectPicker
          values={initial.departments}
          onChange={(values) => changeAttr({ ...initial, departments: values })}
          fetchKey={["DepartmentRUS", "Department"]}
          classNames={{
            contentClassName: "text-base font-normal",
            selectClassName: "!px-2.5",
          }}
          dataField={{
            placeholder: "Выберите отдел",
            type: "peoplePicker",
            require: false,
            title: "Отдел",
            width: "w-full",
            key: "peoplePicker",
            single: true,
          }}
          min={0}
          errors={{}}
        />
      </FlexRow>
      <FlexRow>
        <TGSelectPicker
          values={initial.positions}
          onChange={(values) => changeAttr({ ...initial, positions: values })}
          fetchKey={["TitleRUS", "JobTitle"]}
          classNames={{
            contentClassName: "text-base font-normal",
            selectClassName: "!px-2.5",
          }}
          dataField={{
            placeholder: "Выберите должность",
            type: "peoplePicker",
            require: false,
            title: "Должность",
            width: "w-full",
            key: "peoplePicker",
            single: true,
          }}
          min={0}
          errors={{}}
        />
      </FlexRow>

      <FlexRow className="mb-5 hide-cancel-button">
        <SearchUI
          ref={searchInputRef}
          placeholder="Введите имя сотрудника"
          defaultValue={initial.searchQuery}
          onClick={handleSearch}
          label={"ФИО"}
          labelClass="text-black"
          inputClass="px-2.5 font-normal"
        />
      </FlexRow>
    </FlexCol>
  );
}
